import { defineStore } from 'pinia';
import { ref } from 'vue';
import * as storeApi from '@/api/store';
import { useAuthStore } from './auth';

export const useStoreContextStore = defineStore('store-context', () => {
  const waitingCount = ref(0);
  const onlineDeviceCount = ref(0);
  const lastFetchedAt = ref<number>(0);
  let timer: number | null = null;

  async function refresh(): Promise<void> {
    const auth = useAuthStore();
    if (!auth.storeId) return;
    try {
      const ctx = await storeApi.getStoreContext(auth.storeId);
      waitingCount.value = ctx.waitingCount;
      onlineDeviceCount.value = ctx.onlineDeviceCount;
      lastFetchedAt.value = Date.now();
    } catch {
      // silent: 顶部条不弹错
    }
  }

  function start(): void {
    stop();
    void refresh();
    timer = window.setInterval(() => {
      void refresh();
    }, 30_000);
  }

  function stop(): void {
    if (timer !== null) {
      window.clearInterval(timer);
      timer = null;
    }
  }

  return { waitingCount, onlineDeviceCount, lastFetchedAt, refresh, start, stop };
});
